import { render, staticRenderFns } from "./offsetRecordInfo.vue?vue&type=template&id=32b29ba8&scoped=true&"
import script from "./offsetRecordInfo.vue?vue&type=script&lang=js&"
export * from "./offsetRecordInfo.vue?vue&type=script&lang=js&"
import style0 from "./offsetRecordInfo.vue?vue&type=style&index=0&id=32b29ba8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b29ba8",
  null
  
)

export default component.exports